import axios, { AxiosResponse } from "axios";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";

type FetchChangelogTemplateResponse = {
  changelog_template: string | null;
};
/**
 * Fetches auto-generated changelog template for a tool version
 * @param toolVersionId
 * @returns a string template with suggested changelog entry
 */
export const fetchChangelogTemplate = async (
  toolVersionId: number,
): Promise<FetchChangelogTemplateResponse> => {
  const headers = await getRequestHeaders();

  const res = await axios.get<
    undefined,
    AxiosResponse<FetchChangelogTemplateResponse>
  >(getEnvVar("URL_TRS_TOOL_VERSION_CHANGELOG_TEMPLATE")(toolVersionId), {
    headers,
  });

  return res.data;
};
